import React from 'react';
import { ComposedChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../utils/LoadingSpinner';

const formatDateLabel = (id) => {
	if (!id) return '';
	const { year, month, day, hour, minute } = id;
	let label = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
	if (hour !== undefined) label += ` ${String(hour).padStart(2, '0')}:00`;
	if (minute !== undefined) label = label.replace(':00', `:${String(minute).padStart(2, '0')}`);
	return label;
}

const StatsHealthChart = ({ data, loading }) => {
	if (loading) {
		return <LoadingSpinner loadingMsg='Loading health data' />;
	}

	if (!data || data.length === 0) {
		return <p className='text-center text-muted mt-3'>No health data available</p>;
	}

	const chartData = data.map(item => ({
		label: formatDateLabel(item._id),
		successful: item.successful || 0,
		failed: item.failed || 0,
		success_rate: item.success_rate ? Math.round(item.success_rate * 100) / 100 : 0
	}));

	return (
		<ResponsiveContainer width='100%' height={350}>
			<ComposedChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
				<CartesianGrid strokeDasharray='3 3' />
				<XAxis dataKey='label' fontSize={12} />
				<YAxis yAxisId='left' />
				<YAxis yAxisId='right' orientation='right' domain={[0, 100]} unit='%' />
				<Tooltip />
				<Legend />
				<Area yAxisId='left' type='monotone' dataKey='successful' stackId='1' stroke='#198754' fill='#198754' fillOpacity={0.4} name='Successful' />
				<Area yAxisId='left' type='monotone' dataKey='failed' stackId='1' stroke='#dc3545' fill='#dc3545' fillOpacity={0.4} name='Failed' />
				<Line yAxisId='right' type='monotone' dataKey='success_rate' stroke='#0d6efd' strokeWidth={2} dot={false} name='Success Rate (%)' />
			</ComposedChart>
		</ResponsiveContainer>
	);
}

StatsHealthChart.propTypes = {
	data: PropTypes.array,
	loading: PropTypes.bool
}

export default StatsHealthChart;
